import axios from 'axios'
import exceptionHandler from '../exception-handler'

export default {
  async settings () {
    try {
      const res = await axios.get('/sisense/settings/')
      return res.data
    } catch (error) {
      return exceptionHandler.parse(error)
    }
  },
  async sso () {
    try {
      const res = await axios.get('/sisense/sso?return_to=/app/main')
      return res
    } catch (error) {
      return exceptionHandler.parse(error)
    }
  },
  async logout () {
    try {
      const res = await axios.get('/sisense/logout')
      return res
    } catch (error) {
      return exceptionHandler.parse(error)
    }
  },

  /**
   * Just gets the jwt and then GETs the sisense/jwt url with the token, letting the cookie be hopefully set in the browser.
   * (We can't see the cookie due to its cross-sitedness.)
   * @param {String} sisenseHost
   */
  async ssoLogin (sisenseHost) {
    try {
      const res = await axios.get('/sisense/jwt-token')
      const token = res.data
      if (!token) {
        return ''
      }
      const authUrl = sisenseHost + '/jwt?jwt=' + token + '&return_to=/app/main'
      axios.defaults.withCredentials = true
      await axios.get(authUrl, { maxRedirects: 0 })
      axios.defaults.withCredentials = false
    } catch (error) {
      console.log(error)
    }
  },
  async dashboards (opt) {
    try {
      axios.defaults.withCredentials = true
      const res = await axios.get(opt.sisenseHost + '/api/v1/dashboards?fields=oid%2Ctitle' +
        (opt.parentFolderId ? '&parentFolder=' + opt.parentFolderId : ''))
      axios.defaults.withCredentials = false
      return res.data
    } catch (error) {
      throw error
    }
  }
}
